import store from '~/javascripts/store.js';
import { Component } from 'react';

class ReactPlaidLink extends Component {
  static defaultProps = {
    className: 'PlaidLink',
  };

  componentDidMount() {
    if (store.donateForm.triggerOpenPlaidModal) {
      store.donateForm.triggerOpenPlaidModal = false;
      this.openPlaidModal();
    }
  }

  configurePlaidHandler = () => {
    this.plaidHandler = window.Plaid.create(this.plaidCreateOptions());
  };

  plaidCreateOptions = () => {
    const config = {};

    config.apiVersion = 'v2';
    config.env = this.props.plaidEnv;
    config.token = store.donateForm.plaidItemAddToken;

    const options = [
      'clientName',
      'longtail',
      'onExit',
      'onLoad',
      'onSuccess',
      'product',
      'selectAccount',
      'webhook',
    ];

    options.forEach((option) => {
      if (option in this.props) {
        config[option] = this.props[option];
      }
    });

    return config;
  };

  openPlaidModal = () => {
    store.donateForm.createPlaidItemAddToken(() => {
      if (this.props.afterPlaidClickHandled)
        this.props.afterPlaidClickHandled();
      if (!this.plaidHandler) this.configurePlaidHandler();
      this.plaidHandler.open();
    });
  };

  onClick = () => {
    const plaidButtonContainer = this.link;
    const $parentForm = $(plaidButtonContainer).closest('form');
    const submitButtonDisabled = $(plaidButtonContainer)
      .find('button')
      .get()[0].disabled;
    const donateFormInvalid =
      $parentForm.length && !$parentForm.parsley().validate();

    if (donateFormInvalid || submitButtonDisabled) {
      return;
    }

    if (!store.donateForm.disableMembershipCheck) {
      $.getJSON(
        `/api/v1/spring_membership/${store.donateForm.sanitizedEmail}`,
        (data) => {
          store.donateForm.isAlreadySpringMember = data['is_spring_member'];
          store.donateForm.existingSubscriptionState =
            data['existing_subscription_state'];

          if (
            !store.donateForm.isAlreadySpringMember ||
            store.donateForm.existingSkippedOrFailedPaymentSubscription
          ) {
            this.openPlaidModal();
          }
        }
      );
    } else {
      this.openPlaidModal();
    }
  };

  render() {
    return (
      <span onClick={this.onClick} ref={(el) => (this.link = el)}>
        {this.props.children}
      </span>
    );
  }
}

export default ReactPlaidLink;
